import { Env } from "../../env";

export const getSubdomainUrl = () => {
  const subdomainUrl =
    window.location.hostname == "localhost"
      ? Env.DOCTOR_SUBDOMAIN_URL
      : window.location.hostname;
  return subdomainUrl;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/PatientPlaylistTools.js